import { HttpErrorResponse } from '@angular/common/http';
import { Component, input } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import { ButtonComponent, DepartmentProfessionsComponent, LoaderComponent } from '@camelot/ui';

import { CamTranslationCore } from '../../../../../translation.service';
import { BaseTemplateComponent } from '../base-template';

@Component({
  selector: 'cam-mail-template',
  templateUrl: './mail-template.component.html',
  styleUrls: ['./mail-template.component.scss'],
  imports: [DepartmentProfessionsComponent, LoaderComponent, ButtonComponent, TranslatePipe],
})
export class MailTemplateComponent extends BaseTemplateComponent {
  ctaService = input.required<{
    mail: (id: number) => any;
  }>();

  constructor() {
    super();
    CamTranslationCore.getInstance();
  }

  public override setForm() {}
  public override send() {
    const prospection = this.currentItem;
    this.requestState.asked();
    this.ctaService()
      .mail(prospection.id)
      .subscribe({
        complete: () => {
          this.next();
          this.requestState.completed();
        },
        error: (error: HttpErrorResponse) => {
          this.requestState.onError(error.status, error.statusText);
        },
      });
  }
}
